<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Paradis perdu</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">Par Shira Anthony</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Il est dangereux de chercher des secrets enfouis.</p>
<p class="P_Normal">Lorsqu’une énorme société menace de reprendre son entreprise, Adam Preston, prodige de la programmation, échappe au stress en prenant des vacances plus que méritées en République Dominicaine. Il y rencontre Jonah James, un instructeur de plongée sous-marine, séduisant, intelligent et perspicace. Ce qui commence comme une aventure de vacances devient bientôt beaucoup plus sérieux.</p>
<p class="P_Normal">Mais Jonah a un secret : dix ans auparavant, il s’est réveillé sur une plage de l’île sans savoir comment il y est arrivé… ni même qui il est. Leur paradis n’est peut-être pas aussi parfait qu’il le paraît. Lorsque les souvenirs de Jonah recommencent à affluer comme des vagues sur le sable, Adam s’agrippera-t-il au radeau de sauvetage ou les deux hommes trouveront-ils un havre de sécurité pour se sortir de la tempête ?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?791e4210